import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { AudioPlayerProvider } from "@/contexts/AudioPlayerContext";
import Index from "./pages/Index";
import EventInfo from "./pages/EventInfo";
import VibeBuilder from "./pages/VibeBuilder";
import Shop from "./pages/Shop";
import Auth from "./pages/Auth";
import Dashboard from "./pages/Dashboard";
import SignContract from "./pages/SignContract";
import PayContract from "./pages/PayContract";
import NPSFeedback from "./pages/NPSFeedback";
import NotFound from "./pages/NotFound";
import Audition from "./pages/Audition";
import OpsApp from "./pages/OpsApp";

const queryClient = new QueryClient();

const AnimatedRoutes = () => {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Index />} />
        <Route path="/event-info" element={<EventInfo />} />
        <Route path="/vibe-builder" element={<VibeBuilder />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/auth" element={<Auth />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/sign-contract" element={<SignContract />} />
        <Route path="/pay-contract" element={<PayContract />} />
        <Route path="/feedback/:token" element={<NPSFeedback />} />
        <Route path="/audition" element={<Audition />} />
        <Route path="/ops" element={<OpsApp />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </AnimatePresence>
  );
};

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <AudioPlayerProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <AnimatedRoutes />
        </BrowserRouter>
      </AudioPlayerProvider>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
